/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AzioneStato } from './azione-stato';
import { TipoPraticaStato } from './tipo-pratica-stato';


export interface AzioneStatoDTO { 
    azione?: AzioneStato;
    target?: TipoPraticaStato;
    enabled?: boolean;
    reason_key?: string;
}



